export const processItems = ({
	array,
	checkActive,
	transformArray,
	sortArray,
}) => {
	let items = [...(array ?? [])];

	if (sortArray) {
		items = sortArray(items);
	}

	return items.reduce(
		(acc, obj) => {
			const isActive = checkActive(obj);
			let item = obj;

			if (transformArray) {
				item = transformArray(obj, isActive);
			}

			if (isActive) acc.activeItems.push(item);
			else acc.disabledItems.push(item);

			return acc;
		},
		{ activeItems: [], disabledItems: [] },
	);
};
